import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { HandleLoginWithEmail } from "../../services/Firebase";
import ForgetPassword from "./ForgetPassword";

export default function LogInWithEmail({ onClose }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [agree, setAgree] = useState(true);
    const [error, setError] = useState("");
    const [showLoginModal, setShowLoginModal] = useState(true);
    const [showForget, setShowForget] = useState(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);

    const isValidPassword = password.length > 0;

    const ValidateEmailAddress = (value) => {
        setEmail(value);

        if (!isValidEmail) {
            setError("Enter a valid email address.");
        } else {
            setError("");
        }
    };

    // Show proper error message
    const ValidatePassword = (value) => {
        setPassword(value);

        if (value.length <= 0) {
            setError("Password is required.");
        } else {
            setError("");
        }
    };

    // Final form status
    const isFormValid = isValidEmail && isValidPassword && agree;

    return (
        <div
            className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50 px-4"
            onMouseDown={onClose} // clicking outside closes modal
        >
            {showLoginModal && (
                <div
                    className="bg-black/40 border border-white/20 backdrop-blur-xl w-full max-w-lg rounded-2xl p-8 relative shadow-xl"
                    onMouseDown={(e) => e.stopPropagation()} // clicking inside DOES NOT close modal
                >
                    {/* Close Button */}
                    <button
                        className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 transition"
                        onClick={onClose}
                    >
                        <IoClose />
                    </button>

                    {/* Title */}
                    <h2 className="text-white text-2xl font-semibold text-center">
                        Log in with E-mail
                    </h2>
                    <p className="text-gray-300 text-center mt-2 mb-6">
                        Enter your e-mail and your password
                    </p>

                    {/* Email */}
                    <label className="text-gray-300 text-lg">Email</label>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => ValidateEmailAddress(e.target.value)}
                        className={`w-full px-5 py-3 rounded-full bg-black/40 border ${email === "" || isValidEmail ? "border-white/20" : "border-red-500"
                            } text-white mt-2 mb-4 focus:outline-none`}
                    />

                    {/* Password */}
                    <label className="text-gray-300 text-lg">Password</label>
                    <input
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => ValidatePassword(e.target.value)}
                        className={`w-full px-5 py-3 rounded-full bg-black/40 border ${password === "" || isValidPassword
                            ? "border-white/20"
                            : "border-red-500"
                            } text-white mt-2`}
                    />

                    {/* ERROR MESSAGE */}
                    {error && (
                        <p className="text-red-500 text-sm mt-2 mb-4 px-1">{error}</p>
                    )}

                    {/* Checkbox */}
                    <div className="flex items-center gap-3 mb-6 mt-4">
                        <input
                            type="checkbox"
                            checked={agree}
                            onChange={() => setAgree(!agree)}
                            className="w-5 h-5 accent-green-500"
                        />
                        <p className="text-gray-300">
                            I hereby agree to the{" "}
                            <a href="/terms" className="text-red-500 underline">T&C</a> and{" "}
                            <a href="/privacy" className="text-red-500 underline">Privacy Policy</a>.
                        </p>
                    </div>

                    {/* Continue Button */}
                    <button
                        disabled={!isFormValid}
                        onClick={() => HandleLoginWithEmail(email, password)}
                        className={`w-full py-3 rounded-full text-lg font-semibold transition ${isFormValid
                            ? "bg-red-500 text-white hover:bg-red-500"
                            : "bg-red-500/40 text-gray-400 cursor-not-allowed"
                            }`}
                    >
                        Continue
                    </button>

                    <div className="flex justify-center mt-3">
                        <button
                            onClick={() => setShowForget(true)}
                            className="text-white underline"
                        >
                            Forget Password
                        </button>
                    </div>
                </div>
            )}

            {showForget && (
                <ForgetPassword
                    onClose={() => {
                        setShowForget(false);
                        setShowLoginModal(false);
                        onClose();
                    }}
                    onBack={() => {
                        setShowForget(false);
                        setShowLoginModal(true);
                    }}
                />
            )}
        </div>
    );
}